import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionProgramConsentNode } from "./types";

export interface CommissionProgramConsentsQueryResponse {
  commissionProgramConsents: {
    nodes: CommissionProgramConsentNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionProgramConsentsQueryVariables extends PaginationVariables {
  campaignId: string;
  crmPersonId?: string;
}

export const COMMISSION_PROGRAM_CONSENTS_QUERY: TypedDocumentNode<
  CommissionProgramConsentsQueryResponse,
  CommissionProgramConsentsQueryVariables
> = gql`
  query CommissionProgramConsents(
    $campaignId: ID!
    $crmPersonId: ID
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    commissionProgramConsents(
      campaignId: $campaignId
      crmPersonId: $crmPersonId
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      nodes {
        id
        commissionCampaignId
        crmPersonId
        attributionModel
        ownership
        startsAt
        endsAt
        status
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
